// @flow
import React, {PureComponent} from 'react';
import {StyleSheet, KeyboardAvoidingView} from 'react-native';
import {Field} from 'redux-form';
import {GradientPage, HoshiInput, FullButton} from '../../components/common';
import {PageTitle} from '../../components/signUp';

class HoshiInputWithAutoresize extends PureComponent<any> {
  styles = getStyles();
  render() {
    const length = this.props.input.value && this.props.input.value.length;
    const fontSize = length < 8 ? 40 : length < 12 ? 30 : 20;
    const height = length < 8 ? 80 : length < 12 ? 70 : 60;

    return (
      <HoshiInput
        {...this.props}
        inputStyle={[
          this.styles.input,
          {
            fontSize,
            height,
          },
        ]}
      />
    );
  }
}

class SingleInputForm extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <GradientPage dismissKeyboard iosEdges={['top','bottom']}>
        <KeyboardAvoidingView style={styles.container} behavior="height">
          <PageTitle title={this.props.title} />
          <Field
            name={this.props.name}
            component={HoshiInputWithAutoresize}
            keyboardType={this.props.keyboardType}
            autoCapitalize="none"
            returnKeyType="go"
            style={this.props.style.inputContainer}
            errorStyle={styles.error}
            maxLength={this.props.maxLength}
            onSubmitEditing={this.props.onSubmitEditing}
            normalize={this.props.normalize}
            autoFocus
          />
          <FullButton
            text={this.props.buttonText}
            onPress={this.props.onSubmitEditing}
            isLoading={this.props.isLoading}
          />
        </KeyboardAvoidingView>
      </GradientPage>
    );
  }
}

type Props = {
  onRequestClose: () => void,
  onSubmitEditing?: () => void,
  normalize?: string => string,
  maxLength: number,
  keyboardType: string,
  name: string,
  title: string,
  buttonText: string,
  style: {
    inputContainer: {
      width: number,
      alignSelf: string,
    },
  },
  isLoading: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-around',
      paddingHorizontal: 10,
      paddingVertical: 20,
    },
    input: {
      fontWeight: '300',
      textAlign: 'center',
    },
    error: {
      textAlign: 'center',
      paddingTop: 10,
    },
  });

export default SingleInputForm;
